const SiteWideJackpotGlowBorder = () => {
    return (
        <svg className="glow-border" viewBox="0 0 343 54">
            <defs>
                <filter id="glow" height="150%" width="150%" x="-25%" y="-25%">
                    <feDropShadow dx="0" dy="0" stdDeviation="5" floodColor="#2AF7FF" floodOpacity="0.5" />
                </filter>
            </defs>
            <rect rx="10" ry="10" width="100%" height="100%" />
        </svg>
    );
};

export default SiteWideJackpotGlowBorder;
